
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { Subscription } from 'rxjs';
import { WorkLocationProvider } from '../../shared/nestjs/standardized-data/work-location/work-location';
import { AttendanceLocationApi } from '../../shared/nestjs/gd-only/services/attendance-location.api';
import { JobGradeApi } from '../../shared/nestjs/gd-only/services/job-grade.api';
import { DepartmentApi } from '../../shared/nestjs/gd-only/services/department.api';
import { CostCenterNestApi } from '../../shared/nestjs/gd-only/services/cost-center.api';

/*
  Generated class for the ChangePrivacyBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class StandardizedDataBloc {
	private subscriptions: Array<Subscription> = [];
	constructor(
		public nestApiProvider: NestApiProvider,
		private departmentApi: DepartmentApi,
		public costCenterNestApi: CostCenterNestApi,
		private workLocationProvider: WorkLocationProvider,
		private attendanceLocationProvider: AttendanceLocationApi,
		private jobGradeProvider: JobGradeApi,
	) {

	}

	dispose() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	upload(pageType: string, fileInput: any, params?: any) {
		return new Promise((resolve, reject) => {
			const filesToUpload = <Array<File>>fileInput.target.files;
			this.apiUpload(pageType, filesToUpload[0], params).subscribe((result) => {
				resolve(result)
			}, error => {
				reject(error)
			})
		})
	}

	download(pageType: string, params?: string) {
		return new Promise((resolve, reject) => {
			this.apiDownload(pageType, params).subscribe((result) => {
				resolve(result);
			}, error => {
				reject(error);
			});
		});
	}

	processWebImage(event) {
		return new Promise((resolve, reject) => {
			let name = event.target.files[0].name;
			let fileIMG = ["xls", "xlsx"];
			let formatImage = name.split(".").pop();
			let res = formatImage.toLowerCase();

			const re = /(?:\.([^.]+))?$/;
			const ext = re.exec(name)[1];

			if (ext != "xls" && ext != "xlsx") {
				reject({ message: 'File type is invalid.' });
			}

			if (fileIMG.indexOf(res) < 0) {
				reject({ message: 'File type is invalid.' });
			} else {
				let reader = new FileReader();
				reader.addEventListener("load", () => {
					resolve(event);
				}, false);

				reader.readAsDataURL(event.target.files[0]);
			}
		})
	}

	private apiDownload(pageType, params?: string) {
		switch (pageType) {
			case 'WorkLocation':
				return this.workLocationProvider.downloadTemplate();
			case 'JobGrade':
				return this.jobGradeProvider.downloadTemplate()
			case 'AttendanceLocation':
				return this.attendanceLocationProvider.downloadTemplate()
			case 'AttendanceLocationEmployeeList':
				return this.attendanceLocationProvider.downloadTemplateEmployee(params)
			case 'CostCenter':
				return this.costCenterNestApi.downloadTemplate();
			case 'Organization':
				return this.departmentApi.downloadTemplate();
			default:
				return null;
		}
	}

	private apiUpload(pageType, filesToUpload, params?: any) {
		switch (pageType) {
			case 'WorkLocation':
				return this.workLocationProvider.uploadWorkLocation(filesToUpload);
			case 'JobGrade':
				return this.jobGradeProvider.uploadJobGrade(filesToUpload)
			case 'AttendanceLocation':
				return this.attendanceLocationProvider.uploadAttendanceLocation(filesToUpload)
			case 'AttendanceLocationEmployeeList':
				return this.attendanceLocationProvider.uploadEmployeeAttendanceLocation(params.attLocCode, filesToUpload)
			case 'CostCenter':
				return this.costCenterNestApi.uploadCostCenter(filesToUpload);
			case 'Organization':
				return this.departmentApi.uploadDepartment(filesToUpload);
			default:
				return null;
		}
	}


}




// WEBPACK FOOTER //
// ./src/bloc/settings/standardized-data.bloc.ts